<template>
  <div class="app-toolbar" :class="{ column }">
    <slot />

    <AppToolbarContent v-if="$slots.content">
      <slot name="content" />
    </AppToolbarContent>
  </div>
</template>

<script>
import AppToolbarContent from '@/components/App/Toolbar/Content.vue'

export default {
  name: 'AppToolbar',

  components: {
    AppToolbarContent,
  },

  props: {
    column: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@use '@/styles/settings.scss' as *;
@use '@/styles/functions.scss' as *;

.app-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem 0.5rem;

  &.column {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    > .app-buttons {
      width: 100%;
    }
  }
}
</style>
